export { EventsSlider } from "./events-slider";
